// extracted by mini-css-extract-plugin
module.exports = {"modal__heading":"deleteModal_modal__heading__2LKMz","modal__remainbutton":"deleteModal_modal__remainbutton__3UxXz","modal__deletebutton":"deleteModal_modal__deletebutton__3zpvd"};